const PresentationCell = ({ presentation, room }) => {
  return (
    <td
      className={`presentation room${room.number} ${presentation.category}`}
      rowSpan={Math.floor(presentation.duration / 5)}
    >
      <span className="company">
        <a href={room.url}>{presentation.company}</a>
      </span>

      <span className="presenters">{presentation.presenters}</span>

      <a className="join-link" href={room.url}>
        Join
      </a>
    </td>
  );
};

export default PresentationCell;
